import { render } from "./GridFunctionTips.vue?vue&type=template&id=5b70c4fc&scoped=true"
const script = {}

import "./GridFunctionTips.vue?vue&type=style&index=0&id=5b70c4fc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b70c4fc"]])

export default __exports__